	<!-- Footer -->
    <footer class="main"  *ngIf="isUserLoggedIn">
        &copy; {{FooterText}}
    </footer>